import axiosClient from './axiosClient';

const menuService = {
    // Chỉ giữ lại các hàm lấy dữ liệu Public cho khách hàng (Guest)
    getAllMenus: () => axiosClient.get('/public/menus'),
    getPublicMenus: () => axiosClient.get('/public/menus'),
    getPurposes: (timestamp = '') => axiosClient.get(`/public/purposes${timestamp ? `?_t=${timestamp}` : ''}`)
};

export default menuService;